/**
 * HelpDropdown - Simple help/support contact dropdown
 *
 * Displays a contact email for support inquiries
 */

import React from 'react'
import { Menu } from '@mui/material'

type HelpDropdownProps = {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
}

/**
 * HelpDropdown - Support contact dropdown
 */
// @purpose Header help menu dropdown showing the support contact email
export const HelpDropdown = ({
  anchorEl,
  open,
  onClose,
}: HelpDropdownProps): React.JSX.Element => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      PaperProps={{
        elevation: 8,
        sx: {
          width: 240,
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 28,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      data-testid="help-dropdown"
    >
      <div className="px-4 py-3">
        <div className="text-sm text-gray-700 dark:text-gray-300 mb-2">
          Need Help? Contact
        </div>
        <a
          href="mailto:support@rooncyber.com"
          className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline transition-colors"
          onClick={onClose}
          data-testid="help-link-support-email"
        >
          support@rooncyber.com
        </a>
      </div>
    </Menu>
  )
}

export default HelpDropdown
